/* eslint-disable max-len */
import React, {
    useContext,
    useEffect,
} from 'react';

import {
    Flex,
    VStack,
    Spacer,
    Text,
} from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

import { ToastBoxContext } from '../../contexts/ToastBoxContext';

// images path
import theDiagramPath from '../../resources/theDiagram.png';
import theQuestionsPath from '../../resources/theQuestions.png';
import theReportPath from '../../resources/theReport.jpg';
import theTemplatesPath from '../../resources/theTemplates.jpg';

import TitledImage from '../../components/TitledImage';
import PageTitle from '../../components/PageTitle';
import Process from '../../components/Process';

const stagesData = [
    {
        title: 'Warm-up',
        steps: [
            {
                id: '1',
                description: 'Moderator welcomes and explains logistics',
            },
            {
                id: '2',
                description: 'Company introduces product or system ',
            },
            {
                id: '3',
                description: 'Moderator introduces SusAF',
            },
        ],
        result: 'system vision, knowing effects',
        link: '/warm_up',
    },
    {
        title: 'Capture',
        steps: [
            {
                id: '4',
                description: 'Moderator leads through dimensions w. questions',
            },
            {
                id: '5',
                description: 'Stakeholders brainstorm, reflect and discuss',
            },
            {
                id: '6',
                description: 'Scribe takes notes and denotes cross-references',
            },
        ],
        result: 'Discussion notes',
        link: '/capture',
    },
    {
        title: 'Analysis',
        steps: [
            {
                id: '7',
                description: 'Moderator presents and asks open questions',
            },
            {
                id: '8',
                description: 'Group classifies effects into three orders',
            },
            {
                id: '9',
                description: 'Group identifies chains of effects',
            },
            {
                id: '10',
                description: 'Stakeholders discuss relations across dim.',
            },
            {
                id: '11',
                description: 'Potential actions to mitigate and change ',
            },
        ],
        result: 'Classified effects, Chains of effect',
        link: '/analysis',
    },
    {
        title: 'Synthesis',
        steps: [
            {
                id: '12',
                description: 'Moderator facilitates synthesis of chains of effects into diagram(s).',
            },
            {
                id: '13',
                description: 'Detail diagrams can be added for in-depth visual',
            },
            {
                id: '14',
                description: 'Threats & opportunities  get summarised in report  ',
            },
        ],
        result: 'Diagrams, Report',
        link: '/synthesis',
    },
];

function Home() {
    const {
        toast,
        onCloseToast,
    } = useContext(ToastBoxContext);

    // close toast message if open
    useEffect(
        () => {
            if (toast) {
                onCloseToast();
            }
        },
        [onCloseToast, toast],
    );

    return (
        <VStack
            align="stretch"
            spacing={4}
            role="main"
        >
            <PageTitle
                title="Overview: The SusAF Framework Elements"
            />
            <Text fontSize={18}>
                The
                {' '}
                <span style={{ fontWeight: 'bold' }}> Sustainability Awareness Framework (SusAF) </span>
                is a tool that supports stakeholders with different viewpoints to start a conversation on the
                possible effects of a socio-technical system on sustainability. It aims to raise awareness on the relationship between software and
                sustainability; a comprehensive sustainability impact analysis requires further work.
            </Text>
            <Flex
                background="white"
            >
                {stagesData.map((data) => (
                    <VStack
                        key={data.title}
                        padding={4}
                        alignItems="flex-start"
                    >
                        <Process data={data} />
                    </VStack>
                ))}
            </Flex>
            <Flex>
                <NavLink to="/capture">
                    <TitledImage
                        title="The Questions"
                        imagePath={theQuestionsPath}
                    />
                </NavLink>
                <Spacer />
                <TitledImage
                    title="The Templates"
                    imagePath={theTemplatesPath}
                />
            </Flex>
            <Flex>
                <TitledImage
                    title="The Report"
                    imagePath={theReportPath}
                    width="80%"
                />
                <TitledImage
                    title="The Diagram"
                    imagePath={theDiagramPath}
                />
            </Flex>
        </VStack>
    );
}

export default Home;
